export default "__VITE_ASSET__BvrW_4t8__"